import config from '../../config'
import { authHeader } from '../utils/auth-header'

export const competitionService = {
  getAll
}

async function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  let result = await fetch(`${config.apiUrl}/graphql?query={ competitions {name,_id} }`, requestOptions)
  result = await result.json()

  return result
}



// WEBPACK FOOTER //
// ./src/services/competition.js